import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import template from './colorFormat.jsx';
import compose from '../../hoc/compose';
import * as colorUtil from '../../util/color';
import displayNames from '../displayNames';

var isCloseOrEqual = function isCloseOrEqual(a, b) {
  return Math.abs(b - a) <= 3;
};

var ColorFormat = /*#__PURE__*/function (_React$Component) {
  _inherits(ColorFormat, _React$Component);

  var _super = _createSuper(ColorFormat);

  function ColorFormat(props) {
    var _this;

    _classCallCheck(this, ColorFormat);

    _this = _super.call(this, props);
    _this.state = {
      format: 'HEX',
      hsb: colorUtil.hexToHsb(_this.props.value)
    };
    _this.formats = [{
      value: 'HEX',
      label: 'HEX'
    }, {
      value: 'RGB',
      label: 'RGB'
    }, {
      value: 'HSB',
      label: 'HSB'
    }];

    _this.hexValidator = function (hex) {
      return /^[0-9a-f]{6}$/i.test(hex);
    };

    _this.getRGB = function () {
      return colorUtil.hexToRgb(_this.props.value);
    };

    _this.getHSB = function () {
      return colorUtil.hexToHsb(_this.props.value);
    };

    _this.onRGBChange = function (val, key) {
      return _(_this.props.value).thru(colorUtil.hexToRgb).assign(_defineProperty({}, key, val)).thru(colorUtil.rgbToHex).thru(_this.props.onChange).value();
    };

    var updateHsb = function updateHsb(hsb, key) {
      var hex = colorUtil.hsbToHex(hsb);

      _this.setState({
        hsb: hsb,
        lastChange: key
      }, function () {
        _this.props.onChange(hex);
      });
    };

    _this.onHSBChange = function (val, key) {
      return _(_this.state.hsb).assign(_defineProperty({}, key, val)).thru(function (hsb) {
        return updateHsb(hsb, key);
      }).value();
    };

    return _this;
  }

  _createClass(ColorFormat, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var lastChange = this.state.lastChange;
      var hsb = colorUtil.hexToHsb(nextProps.value);

      var shouldKeepHue = function shouldKeepHue() {
        return hsb.saturation < 5 || hsb.brightness < 5 || isCloseOrEqual(hsb.hue, _this2.state.hsb.hue);
      };

      var stateChange = lastChange ? {
        lastChange: null
      } : {
        hsb: _.defaults({
          hue: shouldKeepHue() ? this.state.hsb.hue : hsb.hue
        }, hsb)
      };
      this.setState(stateChange);
    }
  }, {
    key: "render",
    value: function render() {
      return template.call(this);
    }
  }]);

  return ColorFormat;
}(React.Component);

ColorFormat.displayName = displayNames.COLOR_FORMAT;
ColorFormat.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  invalidHexMessage: PropTypes.string
};
ColorFormat.defaultProps = {};
export default compose(ColorFormat);